import { render } from "./SAMPage.vue?vue&type=template&id=160ec8ae"
import script from "./SAMPage.vue?vue&type=script&lang=js"
export * from "./SAMPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__